import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Message from './message'

type DialogProps = {
    userImage: string
    problem: string
    solution: string
}

const Dialog: React.FunctionComponent<DialogProps> = ({ problem, solution, userImage }) => (
    <Container>
        <Message from={'user'} picture={userImage} message={problem}/>
        <Message from={'byzans'} picture={require('./images/byzans.svg')} message={solution} />
    </Container>
)

const Container = styled.div`
    display: grid;

    grid-row-gap: 8px;

    ${up('tablet')} {
       grid-row-gap: 14px; 
    }
`

export default Dialog